<div data-qa="test-logo-banner" class="banner" [ngClass]="bannerImageClass()"></div>